import React from 'react';
import './bookingList.css';
import { useDispatch, useSelector } from "react-redux";
import { bookingActionSagaAction, getCoachInfoSagaAction } from "../../redux/sagaActions";
import { setUserBarAction } from "../../redux/actions";

const BookingItem = ({ data }) => {
    const dispatch = useDispatch();

    const user = useSelector(state => state.user);

    return (
        <div className="item">
            {
                data.canceled &&
                <div className="item__canceled">Занятие отменено!</div>
            }
            <div className="item__top">
                <div className="item__type">{ data.type }</div>
                <div className="item__count">
                    <div className={ `item__count-marker ${ parseInt(data.users_count) > parseInt(data.max_users) ? 'item__count-marker--overflow' : '' }` }/>
                    {
                        data.hide_users === '1'
                            ?
                            parseInt(data.max_users) > parseInt(data.users_count)
                                ? <div className="item__count-value">Места есть</div>
                                : <div className="item__count-value">Мест нет</div>
                            :
                            <div className="item__count-value">{ `${ data.users_count } / ${ data.max_users }` }</div>
                    }
                </div>
            </div>
            <div className="item__wrapper">
                <div className="item__ico item__ico--time"/>
                <div className="item__value">{ data.time }</div>
            </div>
            {
                data.coach &&
                <div className="item__wrapper">
                    <div className="item__ico item__ico--coach"/>
                    <div className={ `item__value ${ user.id && data.coach_id ? 'item__value--coach' : '' }` }
                        onClick={ () => {
                            // Не отправляем запрос при отсутствии coach_id или user_id
                            if (!data.coach_id || !user.id) return;

                            dispatch(getCoachInfoSagaAction({
                                coach_id: data.coach_id
                            }));
                        } }
                    >{ data.coach }</div>
                </div>
            }
            {
                data.bound_subscriptions &&
                <div className="item__wrapper">
                    <div className="item__ico item__ico--bound-subscription"/>
                    <div className="item__value">Автоматическое списание тренировки</div>
                </div>
            }
            {
                data.start_registration &&
                <div className="item__wrapper">
                    <div className="item__ico item__ico--start-registration"/>
                    <div className="item__value">{ data.start_registration }</div>
                </div>
            }
            {
                data.name &&
                <div className="item__wrapper">
                    <div className="item__ico item__ico--description"/>
                    <div className="item__value">{ data.name }</div>
                </div>
            }

            <div className={ `item__subscribe ${ data.canceled ? 'item__subscribe--inactive' : '' } ${ data.in_booking === 1 ? 'item__subscribe--in-booking' : '' }` } onClick={ () => {
                // Открываем формы авторизации, если пользователь не залогинен
                if (!user.id) {
                    dispatch(setUserBarAction(true));
                    return;
                }

                if (data.in_booking === 1) {
                    if (!window.confirm('Вы действительно хотите отменить запись?')) return;
                }
                else {
                    if (!window.confirm('Вы действительно хотите записаться на занятие?')) return;
                }

                dispatch(bookingActionSagaAction({
                    booking_id: data.id
                }));
            } }>{ data.button }</div>
        </div>
    );
};

export default BookingItem;